import axios from 'axios';

import type { TransferState } from '@bb/users';
import type { IUserCancelOrDenyTransferStateResponse } from '@/app-package';

const cancelOrDenyTransfer = async (
  transferId: string,
  state: TransferState,
) => {
  await axios.post<IUserCancelOrDenyTransferStateResponse>(
    `transfer/cancel_deny/${transferId}/${state}`,
  );
};

export default cancelOrDenyTransfer;
